import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

import user from './user'
import service from './service'
import bet from './bet'
import app from './app'
import trend from './trend'
import thirdparty from './thirdparty'
import message from './message'
import sysParameter from './sysParameter'
import webInfo from './webInfo'
import wallet from './wallet'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user,
        service,
        bet,
        app,
        trend,
        thirdparty,
        message,
        sysParameter,
        webInfo,
        wallet,
    },
    plugins: [createPersistedState()]
})

export default store